module.exports = __webpack_public_path__ + "media/images/flags/tj-03bccf7e7490b7b62920e7ed9c87a1c6.svg";